import { useSuperAdminCreatePartnerStore } from "../../../stores/superadmin/createPartner";
import { useSuperAdminPartnerStore } from "../../../stores/superadmin/superadminpartner";
import {
  createNewPartner,
  getPartner,
  updatePartnerWithoutInvoiceAddress,
} from "../../../services/Api/superadminService";
import { DropZoneMandate } from "../services/DropZoneMandate";
import { getSubscription } from "../../../services/Api/subscriptionService";
import { useEffect } from "react";
import { postMandate } from "../../../services/Api/partnerSuscriptionService";
import {
  showToastError,
  showToastSuccess,
} from "../../../services/Toasts/toasts";

const CreatePartner = () => {
  // Store
  const {
    name,
    setName,
    adress,
    setAdress,
    socialReason,
    setSocialReason,
    isSubscriptionEnabled,
    setIsSubscriptionEnabled,
    startDate,
    setStartDate,
    discountAmount,
    setDiscountAmount,
    discountExpirationDate,
    setDiscountExpirationDate,
    isSubscription,
    setIsSubscription,
    selectedSubscription,
    setSelectedSubscription,
    openDetails,
    setOpenDetails,
    reset,
    displayDiv,
    setDisplayDiv,
    animationClass,
    setAnimationClass,
    partnerData,
    setPartnerData,
    files,
    setFiles,
  } = useSuperAdminCreatePartnerStore();

  const {
    modePartner,
    partnerId,
    setPartnerId,
    sendData,
    setSendData,
    setModePartner,
  } = useSuperAdminPartnerStore();

  const handleCreatePartner = async () => {
    createNewPartner(partnerData)
      .then((res) => {
        // Vérifier le statut de la réponse
        if (res?.status === 200) {
          // La logique pour gérer une création réussie
          if (files.length === 0) {
            setDisplayDiv(false);
            setOpenDetails(false);
            setSendData(!sendData);
            showToastSuccess("Le partenaire a bien été créé");
          } else if (
            files.length > 0 &&
            res?.data.idPartnerSubscription !== 0
          ) {
            postMandate(res?.data.idPartnerSubscription, files)
              .then(() => {
                setSendData(!sendData);
                setDisplayDiv(false);
                setOpenDetails(false);
                setSendData(!sendData);
                showToastSuccess("Le partenaire a bien été créé");
                setFiles([]);
              })
            .catch(() => showToastError("Une erreur s'est produite"));

          }
          reset();
        } else {
          // Gérer les cas où le statut n'est pas 200
          console.error(
            "La création du partenaire a échoué avec le statut: ",
            res?.status
          );
        }
      })
      .catch(() => showToastError("Une erreur s'est produite"));

  };

  useEffect(() => {
    if (openDetails === true) {
      setDisplayDiv(true);
      setAnimationClass("slideInTableFromRight 0.3s forwards");
    } else {
      setAnimationClass("slideOutTableToRight 0.3s forwards");
      setDisplayDiv(false);
    }
  }, [openDetails]);

  useEffect(() => {
    getSubscription()
      .then((res) => {
        const formattedData = res?.data.map((sub: any) => {
          return {
            value: sub.id,
            label: sub.missionLimit,
          };
        });
        setIsSubscription(formattedData);
      })
      .catch(() => showToastError("Une erreur s'est produite"));

  }, [openDetails]);

  // **************** EDIT MODE **************** //
  useEffect(() => {
    if (modePartner === "edit") {
      getPartner(partnerId)
        .then((res) => {
          const data = res?.data;
          setName(data.name);
          setAdress(data.address);
          setSocialReason(data.socialReason);
          setIsSubscriptionEnabled(
            data.PartnerSubscriptions[0].isSubscriptionEnabled
          );
          setDiscountAmount(data.PartnerSubscriptions[0].discountAmount);
          const selectedSubObj = isSubscription?.find(
            (sub) => sub?.value === data.PartnerSubscriptions[0].idSubscription
          );
          setSelectedSubscription(selectedSubObj?.value || 0);
          if (data.PartnerSubscriptions[0].startDate) {
            setStartDate(new Date(data.PartnerSubscriptions[0].startDate));
          } else {
            setStartDate(null);
          }
          if (data.PartnerSubscriptions[0].discountExpirationDate) {
            setDiscountExpirationDate(
              new Date(data.PartnerSubscriptions[0].discountExpirationDate)
            );
          } else {
            setDiscountExpirationDate(null);
          }
        })
      .catch(() => showToastError("Une erreur s'est produite"));

    }
  }, [openDetails, isSubscription]);

  const handleUpdatePartner = () => {
    const dataWithoutAddressInvoice = {
      name,
      address: adress,
      socialReason,
      isSubscriptionEnabled,
      idSubscription: selectedSubscription,
      startDate,
      discountAmount,
      discountExpirationDate,
    };

    updatePartnerWithoutInvoiceAddress(partnerId, dataWithoutAddressInvoice)
      .then(() => {
        setDisplayDiv(false);
        setOpenDetails(false);
      })
      .catch(() => showToastError("Une erreur s'est produite"));

    if (files.length > 0 && partnerId !== 0) {
      postMandate(partnerId, files)
        .then(() => {
          setSendData(!sendData);
          setDisplayDiv(false);
          setOpenDetails(false);
          setSendData(!sendData);
          setFiles([]);
        })
        .catch(() => showToastError("Une erreur s'est produite"));

    }
  };

  return (
    <>
      {displayDiv && (
        <div
          className={`absolute top-0 right-0 w-full h-full bg-gradient-to-br from-slate-50 to-blue-50 z-20 overflow-y-auto`}
          style={{
            animation: animationClass,
          }}
        >
          {/* Contenu principal */}
          <div className="px-6 py-8 max-w-7xl mx-auto mt-8">
            <form onSubmit={(e) => e.preventDefault()} className="space-y-8">
              
              {/* Section Informations Générales */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900">Informations Générales</h2>
                </div>
                
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      Nom du partenaire *
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      required
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setPartnerData("name", e.target.value);
                      }}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="Nom du partenaire"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="socialReason" className="block text-sm font-medium text-gray-700 mb-2">
                      Raison sociale *
                    </label>
                    <input
                      type="text"
                      id="socialReason"
                      name="socialReason"
                      required
                      value={socialReason}
                      onChange={(e) => {
                        setSocialReason(e.target.value);
                        setPartnerData("socialReason", e.target.value);
                      }}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="Raison sociale"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                      Adresse *
                    </label>
                    <input
                      type="text"
                      name="address"
                      id="address"
                      required
                      value={adress}
                      onChange={(e) => {
                        setAdress(e.target.value);
                        setPartnerData("address", e.target.value);
                      }}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="Adresse"
                    />
                  </div>
                </div>
              </div>

              {/* Section Abonnement */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-2 bg-green-100 rounded-lg">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900">Configuration de l'Abonnement</h2>
                </div>
                
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      id="isSubscriptionEnabled"
                      name="isSubscriptionEnabled"
                      className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                      checked={isSubscriptionEnabled}
                      onChange={(e) => {
                        const newValue = e.target.checked;
                        setIsSubscriptionEnabled(newValue);
                        setPartnerData("isSubscriptionEnabled", newValue);
                      }}
                    />
                    <label htmlFor="isSubscriptionEnabled" className="text-sm font-medium text-gray-700">
                      Actif
                    </label>
                  </div>
                  
                  <div>
                    <label htmlFor="plan" className="block text-sm font-medium text-gray-700 mb-2">
                      Plan *
                    </label>
                    <select
                      name="plan"
                      id="plan"
                      required
                      value={selectedSubscription}
                      onChange={(e) => {
                        setSelectedSubscription(parseInt(e.target.value));
                        setPartnerData(
                          "idSubscription",
                          parseInt(e.target.value)
                        );
                      }}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    >
                      <option value="0">Choisir un plan</option>
                      {isSubscription?.map((sub) => (
                        <option key={sub.id} value={sub.value}>
                          Plan {sub.value} - {sub.label} missions
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 mb-2">
                      Date de début *
                    </label>
                    <input
                      type="date"
                      id="startDate"
                      name="startDate"
                      required
                      defaultValue={
                        startDate instanceof Date
                          ? startDate.toISOString().substring(0, 10)
                          : ""
                      }
                      onChange={(e) => {
                        setStartDate(new Date(e.target.value));
                        setPartnerData("startDate", new Date(e.target.value));
                      }}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="discountAmount" className="block text-sm font-medium text-gray-700 mb-2">
                      Remise (%)
                    </label>
                    <input
                      type="number"
                      id="discountAmount"
                      name="discountAmount"
                      value={discountAmount}
                      onChange={(e) => {
                        setDiscountAmount(parseInt(e.target.value));
                        setPartnerData(
                          "discountAmount",
                          parseInt(e.target.value)
                        );
                      }}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0"
                      min="0"
                      max="100"
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
                  <div>
                    <label htmlFor="discountExpirationDate" className="block text-sm font-medium text-gray-700 mb-2">
                      Date d'expiration de la remise
                    </label>
                    <input
                      type="date"
                      id="discountExpirationDate"
                      name="discountExpirationDate"
                      defaultValue={
                        discountExpirationDate instanceof Date
                          ? discountExpirationDate
                              .toISOString()
                              .substring(0, 10)
                          : ""
                      }
                      onChange={(e) => {
                        setDiscountExpirationDate(new Date(e.target.value));
                        setPartnerData(
                          "discountExpirationDate",
                          new Date(e.target.value)
                        );
                      }}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Mandat
                    </label>
                    <DropZoneMandate />
                  </div>
                </div>
              </div>

              {/* Boutons d'action */}
              <div className="flex justify-end gap-4 pt-6">
                <button
                  className="px-6 py-3 bg-gray-100 cursor-pointer text-gray-700 hover:bg-red-100 hover:text-red-700 font-semibold rounded-xl transition-all duration-200 flex items-center gap-2"
                  type="button"
                  onClick={() => {
                    setOpenDetails(false);
                    setModePartner("create");
                    reset();
                  }}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Annuler
                </button>
                <button
                  className="px-8 py-3 bg-gradient-to-r cursor-pointer from-light-lavender to-dark-lavender text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2"
                  type="submit"
                  onClick={() =>
                    modePartner === "create"
                      ? handleCreatePartner()
                      : handleUpdatePartner()
                  }
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {modePartner === "create" ? "Créer le partenaire" : "Modifier le partenaire"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CreatePartner;
